import { Router } from '@angular/router';
import { API_CALL_ERROR } from './../../../store/action';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import {
  UPDATE_PRODUCT_REQUESTED,
  UPDATE_PRODUCT_SUCCEEDED,
  DELETE_PRODUCT_REQUESTED,
  DELETE_PRODUCT_SUCCEEDED,
  CLONE_PRODUCT_REQUESTED,
  CLONE_PRODUCT_SUCCEEDED,
  REPROCESS_IMAGE_REQUESTED,
  ROTATE_IMAGE_REQUESTED,
  ROTATE_IMAGE_SUCCEEDED,
  PRODUCT_EDIT_PAGE_DELETE_IMAGE_SUCCESSED,
  PRODUCT_EDIT_PAGE_DELETE_IMAGE_REQUESTED,
  UPDATE_PRODUCT_SOLD_FORCE_REQUESTED,
  UPDATE_PRODUCT_SOLD_FORCE_SUCCESSED
} from './edit.actions';
import * as _ from 'lodash';
import { ApiService } from '../../../api/api.service';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { UtilityService } from '../../../common/services/utility/utility.service';
import { FETCH_PRODUCT_DETAIL_REQUESTED } from '../detail/detail.actions';

function* updateProduct(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.product.update(action.data).toPromise();
    yield put({ type: UPDATE_PRODUCT_SUCCEEDED, data: result });
    AppInjector.get(NotificationService).show('success', 'Successfully edit product', 5000);
    if (_.isNil(action.no_redirect) || !action.no_redirect) {
      AppInjector.get(UtilityService).redirectAndReset('product');
    } else {
      yield put({ type: FETCH_PRODUCT_DETAIL_REQUESTED, data: action.data.id });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateProductRequested() {
  yield takeEvery(UPDATE_PRODUCT_REQUESTED, updateProduct);
}

function* rotateImage(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.product.rotateImage(action.product_id, action.media_id).toPromise();
    yield put({ type: ROTATE_IMAGE_SUCCEEDED, data: result });
    AppInjector.get(NotificationService).show('success', 'Successfully edit product', 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchRotateImageRequested() {
  yield takeEvery(ROTATE_IMAGE_REQUESTED, rotateImage);
}

function* watchDeleteImageRequested() {
  yield takeEvery(PRODUCT_EDIT_PAGE_DELETE_IMAGE_REQUESTED, function* (action: any) {
    const api = AppInjector.get(ApiService);
    try {
      let result = yield api.product.deleteImage(action.product_id, action.media_id).toPromise();
      yield put({ type: PRODUCT_EDIT_PAGE_DELETE_IMAGE_SUCCESSED, data: result });
      AppInjector.get(NotificationService).show('success', 'Successfully edit product', 3000);
      yield put({ type: FETCH_PRODUCT_DETAIL_REQUESTED, data: action.product_id });
    } catch (e) {
      yield put({ type: API_CALL_ERROR, error: e });
    }
  });
}

function* deleteProduct(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.product.delete(action.data).toPromise();
    yield put({ type: DELETE_PRODUCT_SUCCEEDED });
    router.navigate(['product']);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}


function* watchDeleteProductRequested() {
  yield takeEvery(DELETE_PRODUCT_REQUESTED, deleteProduct);
}

function* updateProductSold(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.product.updateProductSold(action.data.id).toPromise();
    yield put({ type: UPDATE_PRODUCT_SOLD_FORCE_SUCCESSED });
    router.navigate(['product']);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}
function* watchForceSoldProductRequested() {
  yield takeEvery(UPDATE_PRODUCT_SOLD_FORCE_REQUESTED, updateProductSold);
}

function* cloneProduct(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.product.clone(action.data).toPromise();
    yield put({ type: CLONE_PRODUCT_SUCCEEDED });
    router.navigate(['product/edit/' + result.id]);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCloneProductRequested() {
  yield takeEvery(CLONE_PRODUCT_REQUESTED, cloneProduct);
}

function* reprocessImage(action) {
  const api = AppInjector.get(ApiService);
  try {
    yield api.product.reprocessImage(action.data.id).toPromise();
    AppInjector.get(NotificationService).show('success', 'Successfully reprocess product image', 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchReprocessImageRequested() {
  yield takeEvery(REPROCESS_IMAGE_REQUESTED, reprocessImage);
}

export default [watchUpdateProductRequested, watchDeleteProductRequested, watchCloneProductRequested, watchReprocessImageRequested, watchRotateImageRequested, watchDeleteImageRequested, watchForceSoldProductRequested];
